<template>
    <img
        :class="`unit-image ${classes ? classes : ''}`"
        :src="imageUrl"
        draggable="false"
    />
</template>

<script>
import { getAssetUrl } from '../../helpers/assets';
import { THEME_TOURNAMENT_KIT } from '../Game/Game-types';
import {
    UNIT_TYPE_ADMIRAL,
    UNIT_TYPE_ALCHEMIST,
    UNIT_TYPE_ARCHER,
    UNIT_TYPE_ASSASSIN,
    UNIT_TYPE_BANNERMAN,
    UNIT_TYPE_BERSERKER,
    UNIT_TYPE_BISHOP,
    UNIT_TYPE_SABOTEUR,
    UNIT_TYPE_CAVALRY,
    UNIT_TYPE_CROSSBOWMAN,
    UNIT_TYPE_EARL,
    UNIT_TYPE_ENSIGN,
    UNIT_TYPE_FOOTMAN,
    UNIT_TYPE_HERALD,
    UNIT_TYPE_HEAVY_CAVALRY,
    UNIT_TYPE_INFILTRATOR,
    UNIT_TYPE_KNIGHT,
    UNIT_TYPE_LANCER,
    UNIT_TYPE_LIGHT_CAVALRY,
    UNIT_TYPE_MARSHAL,
    UNIT_TYPE_MERCENARY,
    UNIT_TYPE_PIKEMAN,
    UNIT_TYPE_PITCH_THROWER,
    UNIT_TYPE_RAIDER,
    // UNIT_TYPE_HUN,
    UNIT_TYPE_REARGUARD,
    UNIT_TYPE_ROYAL_GUARD,
    UNIT_TYPE_ROYAL_GUARD_NOBILITY,
    UNIT_TYPE_SAPPER,
    UNIT_TYPE_SCOUT,
    UNIT_TYPE_DECOY_COIN_SKIRMISHER,
    UNIT_TYPE_SIEGE_TOWER,
    UNIT_TYPE_SKIRMISHER,
    UNIT_TYPE_SWORDSMAN,
    UNIT_TYPE_TREBUCHET,
    UNIT_TYPE_ROYAL_COIN_BLACK,
    UNIT_TYPE_ROYAL_COIN_WHITE,
    UNIT_TYPE_WAR_DRUMMER,
    UNIT_TYPE_WARLORD,
    UNIT_TYPE_WARRIOR_PRIEST,
    UNIT_TYPE_WAR_WAGON,
    UNIT_TYPE_DECOY_COIN_INFILTRATOR,
	UNIT_TYPE_CORSAIR,
    UNIT_TYPE_OVERLORD,
    UNIT_STATE_DEPLOYED,
    UNIT_TYPE_APPRENTICE,
    UNIT_TYPE_EMISSARY,
    UNIT_TYPE_VANGUARD,
	UNIT_TYPE_PIRATE,
    UNIT_TYPE_ROYAL_COIN,
	UNIT_TYPE_LONGBOAT,
	UNIT_TYPE_EMISSARY_V2,
	UNIT_TYPE_TREBUCHET_V2,
	UNIT_TYPE_TREBUCHET_V3,
	UNIT_TYPE_BERSERKER_V2,
	UNIT_TYPE_WARRIOR_PRIEST_V2,
	UNIT_TYPE_FOOTMAN_V2,
	UNIT_TYPE_COMMANDER,
	UNIT_TYPE_DRAGOON,
	UNIT_TYPE_MARKSMAN,
	UNIT_TYPE_RANGER,
} from '../Unit/Unit-types';

const admiralImage = getAssetUrl('../../assets/units/admiral.png');
const alchemistImage = getAssetUrl('../../assets/units/alchemist.png');
const apprenticeImage = getAssetUrl('../../assets/units/apprentice.png');
const archerImage = getAssetUrl('../../assets/units/archer.png');
const assassinImage = getAssetUrl('../../assets/units/assassin.png');
const bannermanImage = getAssetUrl('../../assets/units/bannerman.png');
const berserkerImage = getAssetUrl('../../assets/units/berserker.png');
const bishopImage = getAssetUrl('../../assets/units/bishop.png');
const saboteurImage = getAssetUrl('../../assets/units/saboteur.png');
const cavalryImage = getAssetUrl('../../assets/units/cavalry.png');
const coinBackImg = getAssetUrl('../../assets/coin_back.png');
const coinBackLightImg = getAssetUrl('../../assets/coin_back_light.png');
const commanderImage = getAssetUrl('../../assets/units/commander.png');
const crossbowmanImage = getAssetUrl('../../assets/units/crossbowman.png');
const dragoonImage = getAssetUrl('../../assets/units/dragoon.png');
const earlImage = getAssetUrl('../../assets/units/earl.png');
const emissaryImage = getAssetUrl('../../assets/units/emissary.png');
const ensignImage = getAssetUrl('../../assets/units/ensign.png');
const footmanImage = getAssetUrl('../../assets/units/footman.png');
const heraldImage = getAssetUrl('../../assets/units/herald.png');
const heavyCavalryImage = getAssetUrl('../../assets/units/heavy_cavalry.png');
const infiltratorImage = getAssetUrl('../../assets/units/infiltrator.png');
const knightImage = getAssetUrl('../../assets/units/knight.png');
const lancerImage = getAssetUrl('../../assets/units/lancer.png');
const lightCavalryImage = getAssetUrl('../../assets/units/light_cavalry.png');
const corsairImage = getAssetUrl('../../assets/units/corsair.png');
const overlordImage = getAssetUrl('../../assets/units/overlord.png');
const marshalImage = getAssetUrl('../../assets/units/marshal.png');
const marksmanImage = getAssetUrl('../../assets/units/marksman.png');
const mercenaryImage = getAssetUrl('../../assets/units/mercenary.png');
const pikemanImage = getAssetUrl('../../assets/units/pikeman.png');
const pirateImage = getAssetUrl('../../assets/units/pirate.png');
const pitchThrowerImage = getAssetUrl('../../assets/units/pitch_thrower.png');
const raiderImage = getAssetUrl('../../assets/units/raider.png');
// const hunImage = getAssetUrl('../../assets/units/hun.png');
const rearguardImage = getAssetUrl('../../assets/units/rearguard.png');
const royalCoinBlackImage = getAssetUrl('../../assets/units/royal_coin_black.png');
const royalCoinBlackAltImage = getAssetUrl('../../assets/units/royal_coin_black_alt.png');
const royalCoinWhiteImage = getAssetUrl('../../assets/units/royal_coin_white.png');
const royalCoinWhiteAltImage = getAssetUrl('../../assets/units/royal_coin_white_alt.png');
const royalGuardImage = getAssetUrl('../../assets/units/royal_guard.png');
const sapperImage = getAssetUrl('../../assets/units/sapper.png');
const scoutImage = getAssetUrl('../../assets/units/scout.png');
const decoyCoinInfiltrator = getAssetUrl('../../assets/units/decoy_coin_infiltrator.png');
const decoyCoinSkirmisher = getAssetUrl('../../assets/units/decoy_coin_skirmisher.png');
const rangerImage = getAssetUrl('../../assets/units/ranger.png');
const siegeTowerImage = getAssetUrl('../../assets/units/siege_tower.png');
const skirmisherImage = getAssetUrl('../../assets/units/skirmisher.png');
const swordsmanImage = getAssetUrl('../../assets/units/swordsman.png');
const trebuchetImage = getAssetUrl('../../assets/units/trebuchet.png');
const vanguardImage = getAssetUrl('../../assets/units/vanguard.png');
const warDrummerImage = getAssetUrl('../../assets/units/war_drummer.png');
const warlordImage = getAssetUrl('../../assets/units/warlord.png');
const longboatImage = getAssetUrl('../../assets/units/longboat.png');
const warWagonImage = getAssetUrl('../../assets/units/war_wagon.png');
const warriorPriestImage = getAssetUrl('../../assets/units/warrior_priest.png');

export default {
    name: 'UnitImage',
    props: [
        'unitType',
        'classes',
        'unitState',
        'theme',
    ],
    computed: {
        images() {
            return {
                [UNIT_TYPE_ADMIRAL]: admiralImage,
                ['COIN_BACK_LIGHT']: coinBackLightImg,
                ['COIN_BACK']: coinBackImg,
                [UNIT_TYPE_ALCHEMIST]: alchemistImage,
                [UNIT_TYPE_APPRENTICE]: apprenticeImage,
                [UNIT_TYPE_ARCHER]: archerImage,
                [UNIT_TYPE_ASSASSIN]: assassinImage,
                [UNIT_TYPE_BANNERMAN]: bannermanImage,
                [UNIT_TYPE_BERSERKER]: berserkerImage,
                [UNIT_TYPE_BERSERKER_V2]: berserkerImage,
                [UNIT_TYPE_BISHOP]: bishopImage,
                [UNIT_TYPE_SABOTEUR]: saboteurImage,
                [UNIT_TYPE_CAVALRY]: cavalryImage,
                [UNIT_TYPE_COMMANDER]: commanderImage,
                [UNIT_TYPE_CROSSBOWMAN]: crossbowmanImage,
                [UNIT_TYPE_DRAGOON]: dragoonImage,
                [UNIT_TYPE_EARL]: earlImage,
                [UNIT_TYPE_EMISSARY]: emissaryImage,
                [UNIT_TYPE_EMISSARY_V2]: emissaryImage,
                [UNIT_TYPE_ENSIGN]: ensignImage,
                [UNIT_TYPE_FOOTMAN]: footmanImage,
                [UNIT_TYPE_FOOTMAN_V2]: footmanImage,
                [UNIT_TYPE_HERALD]: heraldImage,
                [UNIT_TYPE_HEAVY_CAVALRY]: heavyCavalryImage,
                [UNIT_TYPE_INFILTRATOR]: infiltratorImage,
                [UNIT_TYPE_KNIGHT]: knightImage,
                [UNIT_TYPE_LANCER]: lancerImage,
                [UNIT_TYPE_LIGHT_CAVALRY]: lightCavalryImage,
                [UNIT_TYPE_MARKSMAN]: marksmanImage,
                [UNIT_TYPE_CORSAIR]: corsairImage,
                [UNIT_TYPE_OVERLORD]: overlordImage,
                [UNIT_TYPE_MARSHAL]: marshalImage,
                [UNIT_TYPE_MERCENARY]: mercenaryImage,
                [UNIT_TYPE_PIKEMAN]: pikemanImage,
                [UNIT_TYPE_PIRATE]: pirateImage,
                [UNIT_TYPE_PITCH_THROWER]: pitchThrowerImage,
                [UNIT_TYPE_RAIDER]: raiderImage,
                // [UNIT_TYPE_HUN]: hunImage,
                [UNIT_TYPE_REARGUARD]: rearguardImage,
                [UNIT_TYPE_ROYAL_COIN_BLACK]: royalCoinBlackImage,
                [`${UNIT_TYPE_ROYAL_COIN_BLACK}_ALT`]: royalCoinBlackAltImage,
                [UNIT_TYPE_ROYAL_COIN_WHITE]: royalCoinWhiteImage,
                [`${UNIT_TYPE_ROYAL_COIN_WHITE}_ALT`]: royalCoinWhiteAltImage,
                [UNIT_TYPE_RANGER]: rangerImage,
                [UNIT_TYPE_ROYAL_GUARD]: royalGuardImage,
                [UNIT_TYPE_ROYAL_GUARD_NOBILITY]: royalGuardImage,
                [UNIT_TYPE_SAPPER]: sapperImage,
                [UNIT_TYPE_SCOUT]: scoutImage,
                [UNIT_TYPE_DECOY_COIN_INFILTRATOR]: decoyCoinInfiltrator,
                [UNIT_TYPE_DECOY_COIN_SKIRMISHER]: decoyCoinSkirmisher,
                [UNIT_TYPE_SIEGE_TOWER]: siegeTowerImage,
                [UNIT_TYPE_SKIRMISHER]: skirmisherImage,
                [UNIT_TYPE_SWORDSMAN]: swordsmanImage,
                [UNIT_TYPE_TREBUCHET]: trebuchetImage,
                [UNIT_TYPE_TREBUCHET_V2]: trebuchetImage,
                [UNIT_TYPE_TREBUCHET_V3]: trebuchetImage,
                [UNIT_TYPE_VANGUARD]: vanguardImage,
                [UNIT_TYPE_WAR_DRUMMER]: warDrummerImage,
                [UNIT_TYPE_LONGBOAT]: longboatImage,
                [UNIT_TYPE_WAR_WAGON]: warWagonImage,
                [UNIT_TYPE_WARLORD]: warlordImage,
                [UNIT_TYPE_WARRIOR_PRIEST]: warriorPriestImage,
                [UNIT_TYPE_WARRIOR_PRIEST_V2]: warriorPriestImage,
            };
        },
        imageUrl() {
            const images = this.images;
            let unitType = this.unitType;

            const coinBack = this.unitState === UNIT_STATE_DEPLOYED ?
                images['COIN_BACK_LIGHT'] :
                images['COIN_BACK'];

            if (unitType?.startsWith(UNIT_TYPE_ROYAL_COIN) && this.theme === THEME_TOURNAMENT_KIT) {
                unitType += '_ALT';
            }

            return images[unitType] ? images[unitType] : coinBack;
        },
    },
};
</script>

<style scoped lang="scss">

</style>
